import React from 'react'

export const GenericInput = ({ name, register, errors, label, placeholder, required, type = "text"  }) => {
    return (
        <div className="form-floating">
            <input 
                type={type}
                className={`form-control form-control-height ${errors[name] ? 'inError' : ''}`}
                name={name}
                {...register(name, { required: required ? 'Campo requerido' : false })}
                id={`floatingInput-${name}`}
                placeholder={placeholder}
            />
            <label className="label-floating" htmlFor={`floatingInput-${name}`}>
                {label}
            </label>

            {errors[name] && (
                <span className='invalid-feedback d-flex field-validation-error'>
                    <span className="error-message">{errors[name]?.message}</span>
                </span>
            )}
        </div>
    )
}
